import React, { useState } from "react";

import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Typography from "@material-ui/core/Typography";

import { ReactComponent as LerMais } from "../../../assets/novosicones/MeAjuda/LerMais.svg";
import { ReactComponent as LerMenos } from "../../../assets/novosicones/MeAjuda/LerMenos.svg";

import { ReactComponent as ExpandeGrupo } from "../../../assets/novosicones/MeAjuda/expand_more.svg";
import { ReactComponent as RecolheGrupo } from "../../../assets/novosicones/MeAjuda/expand_less.svg";

import "./styles.scss";

const AcordeonFAQ = ({ tema, arrayFAQ, minhaCasaMinhaVida }) => {
  const [answerExpanded, setAnswerExpanded] = useState(false);
  const [grupoSelecionado, setGrupoSelecionado] = useState("");
  const [perguntaSelecionada, setPerguntaSelecionada] = useState("");
  const [showMore, setShowMore] = useState(true);

  var video = "";

  const handleChangePergunta = (panel) => (event, isExpanded) => {
    setAnswerExpanded(isExpanded ? panel : false);
  };

  // função que verifica se na resposta contém o link de um vídeo,
  // se tiver adiciona um iFrame para mostrar o vídeo na tela

  function checkIfContainsVideo(stringResposta) {
    video = "";

    if (stringResposta.includes("https://yout")) {
      let arrayStringResposta = stringResposta.split(" ");

      arrayStringResposta.forEach((item) => {
        if (item.includes("https://yout")) {
          let splitUrlVideo = item.split("/");
          video = splitUrlVideo[splitUrlVideo.length - 1];
          item = "";
        }
      });

      return removeVideoUrl(arrayStringResposta).join(" ");
    } else {
      return stringResposta;
    }
  }

  function removeVideoUrl(arrayStringResposta) {
    let resultFilter = arrayStringResposta.filter(
      (item) => !item.includes("https://yout")
    );
    return resultFilter;
  }

  function setPergunta(id) {
    if (perguntaSelecionada == id) setPerguntaSelecionada("");
    else setPerguntaSelecionada(id);
  }

  return (
    <>
      {arrayFAQ
        .filter((q, i) => (showMore ? i < 10 : true))
        .map((pergunta, index) => {
          return (
            <div key={index}>
              <div
                className="centralized-space-between"
                onClick={() => {
                  if (grupoSelecionado == pergunta.subject)
                    setGrupoSelecionado("");
                  else setGrupoSelecionado(pergunta.subject);
                }}
                style={{
                  height: "44px",
                  width: "calc(100% - 25px)",
                  backgroundColor: tema,
                  margin: "10px 0",
                  padding: "0px 0px 0px 25px",
                  color: "#ffffff",
                  transition: "0.3s",
                  cursor: "pointer",
                }}
                id={"grupo-" + index}
              >
                {minhaCasaMinhaVida && index + " - "}
                {pergunta.questions != undefined && pergunta.subject}
                {pergunta.questions == undefined && pergunta.Pergunta}
                {grupoSelecionado == pergunta.subject ? (
                  <div
                    className="centralized"
                    style={{
                      width: "55px",
                      height: "44px",
                      backgroundColor: tema,
                    }}
                  >
                    <RecolheGrupo />
                  </div>
                ) : (
                  <div
                    className="centralized"
                    style={{
                      width: "55px",
                      height: "44px",
                      backgroundColor: tema,
                    }}
                  >
                    <ExpandeGrupo />
                  </div>
                )}
              </div>
              <div
                style={
                  grupoSelecionado == pergunta.subject
                    ? { height: "auto", visibility: "visible" }
                    : { height: "0", visibility: "hidden" }
                }
              >
                <AccordionDetails>
                  <div className="centralized-column">
                    <Typography
                      style={{ color: "#4D4D4D" }}
                      id={`respostaId${pergunta.subject}`}
                    >
                      {pergunta.questions == undefined && pergunta.Resposta}

                      {pergunta.questions != undefined &&
                        pergunta.questions.map((answer) => {
                          return (
                            <Accordion
                              expanded={answerExpanded == answer.id}
                              onChange={handleChangePergunta(answer.id)}
                              onClick={() => {
                                setPergunta(answer.id);
                              }}
                              key={answer.id}
                              accessKey={answer.id}
                              id={`perguntaId${answer.id}`}
                            >
                              <AccordionSummary
                                expandIcon={
                                  perguntaSelecionada == answer.id ? (
                                    <LerMenos style={{ fill: "#ffffff" }} />
                                  ) : (
                                    <LerMais style={{ fill: "#ffffff" }} />
                                  )
                                }
                                aria-controls="panel1bh-content"
                                style={{
                                  backgroundColor: "#ebebeb",
                                  color: "#000000",
                                }}
                              >
                                <Typography
                                  sx={{
                                    width: "33%",
                                    flexShrink: 0,
                                    backgroundColor: "#654987",
                                  }}
                                >
                                  {minhaCasaMinhaVida && answer.id + " - "}
                                  {answer.Pergunta}
                                </Typography>
                              </AccordionSummary>
                              <AccordionDetails>
                                <div className="centralized-column">
                                  <Typography
                                    style={{ color: "#4D4D4D" }}
                                    id={`respostaId${answer.id}`}
                                  >
                                    {checkIfContainsVideo(answer.Resposta)}
                                  </Typography>
                                  {video != "" && (
                                    <iframe
                                      width="560"
                                      height="315"
                                      src={`https://www.youtube.com/embed/${video}`}
                                      title="YouTube video player"
                                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                      style={{ marginTop: "15px" }}
                                    />
                                  )}
                                </div>
                              </AccordionDetails>
                            </Accordion>
                          );
                        })}
                    </Typography>
                    {video != "" && (
                      <iframe
                        width="560"
                        height="315"
                        src={`https://www.youtube.com/embed/${video}`}
                        title="YouTube video player"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        style={{ marginTop: "15px" }}
                      />
                    )}
                  </div>
                </AccordionDetails>
              </div>
            </div>
          );
        })}
      {arrayFAQ.length > 10 && showMore && (
        <div className="centralized btnLerMais">
          <button
            onClick={(e) => {
              e.preventDefault();
              setShowMore(false);
            }}
            style={{
              color: tema,
            }}
            className="centralized"
            id="btnMeAjudaLerMaisPerguntas"
          >
            Outras perguntas
            <span
              className="centralized"
              style={{
                backgroundColor: tema,
              }}
            >
              <LerMais style={{ fill: "#ffffff" }} />
            </span>
          </button>
        </div>
      )}
    </>
  );
};

export default AcordeonFAQ;
